import { convertToRole, roleCollectionKey } from "@/entities/role";
import firebase from "firebase/app";

export async function getStudentExternalInfoFromRef(
  studentRef: firebase.firestore.DocumentReference
) {
  const snapshot = await firebase
    .firestore()
    .collection(roleCollectionKey)
    .doc(studentRef.id)
    .get();
  if (!snapshot || !snapshot.exists || !snapshot.data()) return null;

  const role = convertToRole(snapshot.data()!, snapshot.ref);

  if (role.data.type !== "student") return null;

  return {
    studentDocId: studentRef.id,
    googleAccount: role.data.gmail ?? null,
    microsoftAccount: role.data.microsoftEmail ?? null
  };
}
